export const CallData = [
    {
        "img":"1.jpg",
        "name":"Vincent Porter",
        "status":"Hello Name",
        "class":"away",
        date:"  5 May, 4:40 PM",
        color:"success"
    },
    {
        "img":"2.png",
        "name":"Aiden Chavez",
        "status":"Out is my favorite.",
        "class":"online",
        date:"  5 May, 5:50 PM",
        color:"danger"
    },
    {
        "img":"8.jpg",
        "name":"Prasanth Anand",
        "status":"Change for anyone.",
        "class":"online",
        date:"  5 May, 5:50 PM",
        color:"danger"
    },
    {
        "img":"4.jpg",
        "name":"Venkata Satyamu",
        "status":"First bun like a sun.",
        "class":"offline",
        date:"  5 May, 5:50 PM",
        color:"success"
    },
    {
        "img":"5.jpg",
        "name":"Ginger Johnston",
        "status":"it's my life. Mind it.",
        "class":"online",
        date:"  5 May, 5:50 PM",
        color:"success"
    },
    {
        "img":"8.jpg",
        "name":"Kori Thomas",
        "status":"Change for anyone.",
        "class":"offline",
        date:"  5 May, 5:50 PM",
        color:"danger"
    },
    {
        "img":"1.jpg",
        "name":"Vincent Porter",
        "status":"Hello Name",
        "class":"online",
        date:"  5 May, 5:50 PM",
        color:"success"
    },
    {
        "img":"8.jpg",
        "name":"Kori Thomas",
        "status":"Change for anyone.",
        "class":"online",
        date:"  5 May, 5:50 PM",
        color:"danger"
    }
  ];
  